import React from 'react'
import { withRouter } from 'react-router-dom'

import ArrowLeftIcon from '../../../assets/icons/arrow-left.svg'

const BackButton = ({ history, handleGoBack, className = undefined }) => {
  return (
    <button className={`content-header-back-trigger ${className}`} 
      onClick={() => {
        if (handleGoBack) {
          handleGoBack()
        } else {
          history.goBack()
        }}}>
      <span className="icon">
        <ArrowLeftIcon />
      </span>
      <span>Назад</span>
    </button>
  )
}

export default withRouter(BackButton)